<template>
    <div>
        <board-filter data-aos="fade-up" class="mb-40px mb-md-80px" />

        <v-row data-aos="fade-up" data-aos-delay="200">
            <!-- S: media -->
            <v-col cols="6" md="4" v-for="(insight, index) in insights" :key="index">
                <card-primary class="media-item v-card--none-active-bg cursor-pointer plus-btn-card" @click="open(insight.youtube.id)">
                    <v-responsive :aspect-ratio="464 / 260" class="media-item__thumb image-card w-100" :style="`background-image: url('${baseURL}${insight.thumb}')`" />
                    <div class="pt-16px pt-md-36px pb-10px pb-md-20px">
                        <u-txt-default class="txt--light line-height-14 pb-8px pb-md-16px">
                            <v-row no-gutters>
                                <v-col>
                                    {{ insight.label }}
                                </v-col>
                                <v-col cols="auto">
                                    {{ $dayjs(insight.createdAt).format("YYYY-MM-DD") }}
                                </v-col>
                            </v-row>
                        </u-txt-default>
                        <u-tit-default class="tit--sm line-height-15 font-weight-medium text-truncate-2">
                            {{ insight.subject }}
                        </u-tit-default>
                        <icon-plus size="small" class="grey--text mt-24px mt-md-48px" />
                    </div>
                </card-primary>
            </v-col>
            <!-- E: media -->

            <v-col cols="12" v-if="showsMore">
                <v-layout justify-center>
                    <v-progress-circular indeterminate size="100" width="5" v-intersect="onIntersectMore" />
                </v-layout>
            </v-col>
        </v-row>
        <v-bottom-sheet :value="!!selectedVideo" eager fullscreen content-class="mw-100 h-100" max-width="100%" width="100%">
            <v-btn x-large absolute top right icon text tile color="white" style="z-index: 10" @click="close">
                <icon-close />
            </v-btn>
            <v-responsive max-width="1440" :aspect-ratio="1440 / 810" v-if="selectedVideo">
                <iframe :src="'https://www.youtube.com/embed/' + selectedVideo" class="w-100 h-100 d-block" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" allowfullscreen />
            </v-responsive>
        </v-bottom-sheet>
    </div>
</template>

<script>
import api from "@/api";
import { PANSIM_TYPES } from "@/assets/variables";
import BoardFilter from "@/components/client/board/board-filter.vue";
import IconPlus from "@/components/publish/styles/icons/icon-plus.vue";
import UTitDefault from "@/components/publish/styles/typography/u-tit-default.vue";
import UTxtDefault from "@/components/publish/styles/typography/u-txt-default.vue";
import UTxtMedium from "@/components/publish/styles/typography/u-txt-medium.vue";
import IconClose from "@/components/publish/styles/icons/icon-close.vue";
import CardPrimary from "@/components/publish/parents/cards/card-primary.vue";

let code_default = "youtube";
let site_default = PANSIM_TYPES.SEX_OFFENCE.value;
let baseURL = process.env.VUE_APP_PASIM_URL;

export default {
    props: {},
    components: {
        BoardFilter,
        IconPlus,
        UTitDefault,
        UTxtDefault,
        UTxtMedium,
        IconClose,
    },
    data: () => ({
        insights: [],
        summary: { totalCount: 0 },

        page: 1,
        limit: 30,

        loading: false,
        selectedVideo: null,

        baseURL,
    }),
    computed: {
        showsMore() {
            return 0 < this.summary.totalCount && this.page * this.limit < this.summary.totalCount;
        },
        headers() {
            return {
                skip: (this.page - 1) * this.limit,
                limit: this.limit,
            };
        },
        params() {
            let { ...params } = this.$route.query;

            delete params["page"];

            params["code"] = code_default;
            params["site"] = site_default;

            params["searchKey"] = params["searchKey"] || "subject";
            params["searchValue"] = params["searchValue"] || null;

            if (!params["searchValue"]) delete params["searchValue"];

            return params;
        },
    },
    methods: {
        async init() {
            this.insights = [];
            this.summary = { totalCount: 0 };
            this.page = 1;
            await this.search();
        },
        async search() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { headers, params } = this;
                let { summary, insights } = await api.v1.insights.gets({
                    headers,
                    params,
                });

                this.insights = this.insights.concat(...insights);
                this.summary = summary;
            } finally {
                this.loading = false;
            }
        },
        onIntersectMore(entries, observer, isIntersecting) {
            if (!isIntersecting) return;
            if (this.loading) return;
            this.page += 1;
            this.search();
        },
        open(video) {
            this.selectedVideo = video;
        },
        close() {
            this.selectedVideo = null;
        },
    },
    watch: {
        params() {
            this.init();
        },
    },
    mounted() {
        this.init();
    },
};
</script>

<style lang="scss" scoped>
.media-item {
    display: block;
}
::v-deep {
    .v-bottom-sheet {
        background-color: rgba(0, 0, 0, 0.8) !important;
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 12px;
        .v-btn--absolute.v-btn--top.v-btn--right {
            top: 6px;
            right: 6px;
        }
    }
}
@media (min-width: 576px) {
}
@media (min-width: 768px) {
    ::v-deep {
        .v-bottom-sheet {
            .v-btn--absolute.v-btn--top.v-btn--right {
                top: 50px;
                right: 50px;
            }
        }
    }
}
@media (min-width: 1024px) {
    .media-item {
        display: block;
        &__thumb {
            position: relative;
            &::after {
                content: "";
                display: block;
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                background-color: rgba(23, 28, 33, 0.4);
                opacity: 0;
                visibility: hidden;
                transition: 0.3s ease-out;
            }
        }
        &:hover {
            .media-item__thumb {
                &::after {
                    opacity: 1;
                    visibility: visible;
                }
            }
        }
    }
}
@media (min-width: 1200px) {
}
</style>
